import React from "react";
import { Box, Card, Typography, Tooltip } from "@mui/joy";
import LockIcon from "@mui/icons-material/Lock";

interface Badge {
  id: string;
  name: string;
  description: string;
  icon: string;
  unlocked: boolean;
  category: "milestone" | "category";
}

interface TravelBadgesProps {
  badges: Badge[];
}

export const TravelBadges = ({ badges }: TravelBadgesProps) => {
  const unlockedBadges = badges.filter((b) => b.unlocked);

  return (
    <Box>
      <Typography level="h4" marginBottom={1}>
        Travel Badges
      </Typography>

      <Typography
        level="body-sm"
        sx={{ color: "text.secondary", marginBottom: 2 }}
      >
        Unlocked ({unlockedBadges.length}/{badges.length})
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        {badges.map((badge) => (
          <Tooltip
            key={badge.id}
            title={`${badge.name}: ${badge.description}`}
            placement="top"
          >
            <Card
              variant={badge.unlocked ? "solid" : "outlined"}
              sx={{
                width: 60,
                height: 60,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                opacity: badge.unlocked ? 1 : 0.4,
                backgroundColor: badge.unlocked
                  ? "primary.500"
                  : "background.level1",
                cursor: "default",
                transition: "transform 0.2s",
                "&:hover": {
                  transform: badge.unlocked ? "scale(1.1)" : "none",
                },
              }}
            >
              {badge.unlocked ? (
                <Typography level="h3">{badge.icon}</Typography>
              ) : (
                <LockIcon sx={{ color: "text.tertiary" }} />
              )}
            </Card>
          </Tooltip>
        ))}
      </Box>

      {badges.length === 0 && (
        <Typography
          level="body-sm"
          sx={{ color: "text.tertiary", textAlign: "center", padding: 2 }}
        >
          No badges available yet.
        </Typography>
      )}
    </Box>
  );
};
